import { h, Component } from 'preact';
import s from 'components/bolt/videoOverlayLoader/videoOverlayLoader.sss';
import 'store/bolt/videoOverlay';

import { joinClasses } from 'utils/utils';

export default class VideoOverlayLoader extends Component {
	constructor(props) {
		super(props);
	}

	componentWillReceiveProps(nextProps) {
		if (nextProps.store.videos.overlayOpen) {
			this.load();
		}
	}

	load() {
		if (this.loadStarted) {
			return;
		}
		this.loadStarted = true;

		import(/* webpackChunkName: "videos" */ 'components/bolt/videos/videos').then(component => {
			this.component = component;
			this.setState({ componentLoaded: true });
		});
	}

	render(props) {
		const overlayOpen = props.store.videos?.overlayOpen;

		let content = <div class={joinClasses({ s, videoOverlayLoader: true, displayed: overlayOpen })} />;
		if (overlayOpen && this.component) {
			const Comp = this.component.default;
			content = <Comp {...props} />;
		}

		return content;
	}
}
